<template>
  <b-row>
    <b-col>
      <b-row :align-h="(showMore || alterarInformacao) ? 'between' : 'start'">
        <b-col
          :cols="(showMore) ? 6 : (alterarInformacao) ? 10 : 12"
        >
          <h4 v-if="showTitulo">
            <slot name="complemento-numero" /> {{ titulo }} <slot name="complemento-titulo" /></h4>
          <fieldset class="font-weight-bold text-muted small">
            {{ descricao }}
          </fieldset>
        </b-col>
        <b-form-group
          v-if="showMore"
          class="col-6 my-0 pb-0"
        >
          <b-form-checkbox
            v-model="mostrar"
            class="custom-control-primary"
            style="float:right"
            name="check-button"
            switch
            @change="enviarParaPai"
          >
            <label style="font-size: 1rem">{{ textoMostrar }}</label>
          </b-form-checkbox>
        </b-form-group>

        <slot name="custom-button" />

      </b-row>
      <b-row>
        <b-col cols="12">
          <hr
            class="mx-0 mt-0 mb-2"
            style="border-top: 1px solid #a3a4a66b !important;"
          >
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<style lang="scss">
.icone-acao {
  padding: 0.4rem;
}
</style>

<script>
export default {
  name: 'DivisoriaDescricao',
  props: {
    titulo: {
      type: String,
      required: true,
    },
    descricao: {
      type: String,
      required: true,
    },
    showMore: {
      type: Boolean,
      default: false,
    },
    textoMostrar: {
      type: String,
      default: '',
    },
    mostrarDados: {
      type: Boolean,
      default: true,
    },
    showTitulo: {
      type: Boolean,
      default: true,
    },
    alterarInformacao: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      mostrar: this.mostrarDados,
    }
  },
  watch: {
    mostrarDados(value, oldValue) {
      if (value !== oldValue) {
        this.mostrar = value
      }
    },
  },
  methods: {
    enviarParaPai(value) {
      this.$emit('change', value)
    },
  },
}
</script>
